var map = {
	"./": "04qB",
	"./Preview": "I/C4",
	"./Preview.vue": "I/C4",
	"./index": "04qB",
	"./index.js": "04qB",
	"./pagesData": "eZY3",
	"./pagesData.js": "eZY3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31BR";


//////////////////
// WEBPACK FOOTER
// ./src/pages ^\.\/.*$
// module id = 31BR
// module chunks = 1